// extracted by mini-css-extract-plugin
export default {"colorBrand":"#254a91","colorWhite":"#fff","colorBlueBright":"#81a9f2","TabButton":"TabButton_MT3R9","active":"active_B5PpF","Icon":"Icon_rZZOI","Text":"Text_OOjzg"};